<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Jaris Ash has held various office-based jobs in the past, but she has always had a passion for writing and a love for dogs. Eventually, she decided to combine her two interests, writing from a dog’s perspective for her local training club newsletter, and creating a series of stories for use in Animal Assisted Therapy sessions. All of the characters in her stories are inspired by her real-life dogs, who have made the recent years extremely interesting, even though they have driven her a bit bonkers at times. With trips round Europe – all the way across to Tunnel Harry in Poland on one occasion – as well as agility Have-A-Go events at local schools, fairs and fetes, it’s safe to say that things are never dull in her household.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?734bf7b2